<template>
	<div class="wzry_content">
		<div class="wzry_form">
			<div class="utitle">
				召唤师你好,
				<br />
				欢迎进入虚贝账号评估系统
			</div>
			<div class="form-input">
				<div class="finput" @click="toShow(hero_num, 1)">
					<span class="num">英雄数量</span>
					<span class="val">
						<em>{{ hero_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>
				<div class="finput" @click="toShow(skin_num, 2)">
					<span class="num">皮肤数量</span>
					<span class="val">
						<em>{{ skin_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow(yearSkin_num, 3)">
					<span class="num">年限皮肤数</span>
					<span class="val">
						<em>{{ year_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow(limit_num, 4)">
					<span class="num">限定皮肤数</span>
					<span class="val">
						<em>{{ limit_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow(dw_num, 5)">
					<span class="num">段位</span>
					<span class="val">
						<em>{{ dw_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>
			</div>
		</div>

		<div class="ftBtn">
			<router-link to="/" class="fh"><img src="/static/images/returnBtn.png" /></router-link>
			<div class="gz" @click="guzhi"><img src="/static/images/gzBtn.png" /></div>
		</div>

		<vue-pickers
			:show="show"
			:columns="columns"
			:defaultData="defaultData"
			:isRemember="true"
			:selectData="pickerData"
			@cancel="close"
			@confirm="confirmFn"
		></vue-pickers>
		<div class="mask" v-if="isMask"></div>
	</div>
</template>

<script>
import vuePickers from 'vue-pickers';
import { Toast } from 'mint-ui';
export default {
	name: 'home',
	components: { vuePickers, Toast },
	data: function () {
		return {
			id: this.$route.query.id,
			username: this.$route.query.username,
			isMask: false,
			show: false,
			type: 1,
			columns: 1,
			pickerData: {},
			defaultData: [],
			hero_defaultData: [{ text: '0-30', value: '720' }],
			hero_num: {
				data1: [
					{ text: '0-30', value: '720' },
					{ text: '31-60', value: '2640' },
					{ text: '61-90', value: '3600' },
					{ text: '91-120', value: '5040' },
					{ text: '121-140', value: '6480' },
					{ text: '140以上', value: '6768' }
				]
			},
			skin_defaultData: [{ text: '0-200', value: '3740' }],
			skin_num: {
				data1: [
					{ text: '0-200', value: '3740' },
					{ text: '201-400', value: '17340' },
					{ text: '401-600', value: '34000' },
					{ text: '601-800', value: '47600' },
					{ text: '800以上', value: '60248' }
				]
			},
			// 年限皮肤
			year_defaultData: [{ text: '0~1', value: '900' }],
			yearSkin_num: {
				data1: [
					{ text: '0~1', value: '900' },
					{ text: '2~3', value: '1800' },
					{ text: '4~5', value: '4500' },
					{ text: '6~7', value: '5400' },
					{ text: '8及以上', value: '7200' }
				]
			},
			//限定皮肤
			limit_defaultData: [{ text: '0~8', value: '1200' }],
			limit_num: {
				data1: [
					{ text: '0-8', value: '1200' },
					{ text: '9~16', value: '2600' },
					{ text: '17~24', value: '3800' },
					{ text: '25~32', value: '5600' },
					{ text: '33以上', value: '6600' }
				]
			},
			//段位
			dw_defaultData: [{ text: '青铜', value: '50' }],
			dw_num: {
				data1: [
					{ text: '青铜', value: '50' },
					{ text: '白银', value: '150' },
					{ text: '黄金', value: '300' },
					{ text: '铂金', value: '500' },
					{ text: '钻石', value: '1500' },
					{ text: '大师', value: '2000' },
					{ text: '最强王者', value: '5000' }
				]
			}
		};
	},
	mounted() {
		document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
			WeixinJSBridge.call('hideToolbar');
		});
	},
	methods: {
		toShow(data, type) {
			console.log(data);
			this.show = true;
			this.isMask = true;
			this.pickerData = data;
			this.type = type;

			if (type === 1) {
				this.defaultData = this.hero_defaultData;
			} else if (type === 2) {
				this.defaultData = this.skin_defaultData;
			} else if (type === 3) {
				this.defaultData = this.year_defaultData;
			} else if (type === 4) {
				this.defaultData = this.limit_defaultData;
			} else if (type === 5) {
				this.defaultData = this.dw_defaultData;
			}
		},
		close() {
			this.show = false;
			this.isMask = false;
		},
		confirmFn(val) {
			console.log(val);
			this.show = false;
			this.isMask = false;
			let type = this.type;
			if (type === 1) {
				this.hero_defaultData = [val.select1];
				// this.defaultData = [val.select1]
			} else if (type === 2) {
				this.skin_defaultData = [val.select1];
			} else if (type === 3) {
				this.year_defaultData = [val.select1];
			} else if (type === 4) {
				this.limit_defaultData = [val.select1];
			} else if (type === 5) {
				this.dw_defaultData = [val.select1];
			}
		},
		guzhi() {
			var guzhi =
				Number(this.hero_defaultData[0].value) +
				Number(this.skin_defaultData[0].value) +
				Number(this.year_defaultData[0].value) +
				Number(this.limit_defaultData[0].value) +
				Number(this.dw_defaultData[0].value);
			this.$router.push({ path: '/animation?id=2&username=' + this.username + '&amountValue=' + guzhi });
		}
	}
};

// 百度统计代码
var _hmt = _hmt || [];
(function () {
	var hm = document.createElement('script');
	hm.src = 'https://hm.baidu.com/hm.js?ad99db41be5b87499521b6c4980a6ec2';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(hm, s);
})();
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
.wzry_content {
	width: 10rem;
	margin: 0 auto;
	background: #1d2425 url(/static/images/yxlm.jpg) no-repeat;
	background-size: 100% auto;
	.wzry_form {
		padding-top: px2rem(260rem);
		padding-bottom: px2rem(165rem);
		.utitle {
			color: #b2fafd;
			font-size: px2rem(40rem);
			padding: 0 px2rem(70rem);
			margin-bottom: px2rem(64rem);
			letter-spacing: 1px;
			font-weight: bold;
			text-shadow: 1px 1px 2px #054346;
		}
		.form-input {
			text-align: center;
			.finput {
				width: px2rem(610rem);
				height: px2rem(90rem);
				line-height: px2rem(90rem);
				background: #223034;
				color: #ffddb5;
				border-radius: 5px;
				padding: 0 px2rem(15rem);
				margin: 0 auto;
				font-size: px2rem(30rem);
				position: relative;
				text-align: left;
				overflow: hidden;
				margin-bottom: px2rem(30rem);
				.num {
					color: #8ab9c3;
					float: left;
				}
				.val {
					color: #e8fefd;
					float: right;
					em {
						font-style: normal;
						padding-right: px2rem(20rem);
						opacity: 0.7;
					}
					img {
						width: px2rem(39rem);
						height: px2rem(23rem);
					}
				}
			}
		}
	}
	.ftBtn {
		display: flex;
		background: #000;
		padding: px2rem(20rem) 0;
		width: 100%;
		position: fixed;
		left: 0;
		bottom: 0;
		.fh {
			flex: 1;
			margin-left: px2rem(10rem);
			img {
				width: px2rem(252rem);
				height: px2rem(106rem);
			}
		}
		.gz {
			margin-right: px2rem(20rem);
			img {
				width: px2rem(436rem);
				height: px2rem(105rem);
			}
		}
	}

	.submitBtn {
		text-align: center;
		padding-top: px2rem(20rem);
		img {
			width: px2rem(616rem);
			height: px2rem(105rem);
		}
	}
	.copyRight {
		text-align: center;
		margin-top: px2rem(140rem);
		img {
			width: px2rem(419rem);
			height: px2rem(31rem);
		}
	}
}

.btnbox {
	display: flex;
	justify-content: center;
}
.btn {
	background: #2e68fa;
	color: #fff;
	padding: 5px 10px;
	display: inline-block;
	margin: 0 10px;
	font-size: 14px;
	border-radius: 4px;
}
.result {
	text-align: center;
	padding: 10px;
}
.isCopy {
	margin: 10px;
	border: 1px dashed red;
	text-align: center;
}

.wzry_content /deep/ .area_grid {
	border-top: 2px solid transparent;
	border-bottom: 2px solid transparent;
	-webkit-border-image: url(/static/images/dotted.jpg) 30 30 round;
	-o-border-image: url(/static/images/dotted.jpg) 30 30 round;
	border-image: url(/static/images/dotted.jpg) 30 30 round;
}

.wzry_content /deep/ .area_ctrl {
	font-size: 12px;
	vertical-align: middle;
	background-color: #413c3c;
	color: #fff;
	margin: 0;
	height: auto;
	width: 100%;
	position: fixed;
	width: 100%;
	left: 0;
	bottom: 0;
	z-index: 9901;
	overflow: hidden;
}

.wzry_content /deep/ .area_btn_box {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
	-webkit-box-align: stretch;
	-ms-flex-align: stretch;
	align-items: stretch;
	background-color: #393333;
	position: relative;
}

.wzry_content /deep/ .tooth {
	color: #fff;
	height: 2em;
	line-height: 2em;
	text-align: center;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	line-clamp: 1;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	overflow: hidden;
}

.wzry_content /deep/ .area_btn {
	color: #999;
	font-size: 1.6em;
	line-height: 1em;
	text-align: center;
	padding: 0.8em 1em;
}

.wzry_content /deep/ .larea_finish {
	color: #ffddb5;
}

.wzry_content /deep/ .area_btn_box:before,
.wzry_content /deep/ .area_btn_box:after {
	content: '';
	position: absolute;
	height: 1px;
	width: 100%;
	display: block;
	background-color: transparent;
	z-index: 15;
	-webkit-transform: scaleY(0.33);
	transform: scaleY(0.33);
}

.mask {
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 999;
	background: #000;
	opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/pages/game/yxlm.vue